import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import './Home.css';
import { About } from '../about/About';
import { Services } from '../services/Services';
import { Gallery } from '../gallery/Gallery';
import { ServiceLocations } from '../ServiceLocations/ServiceLocations';
import { Contact } from '../contact/Contact';
import { Testimonials } from '../testimonials/Testimonials';

export function Home() {
  const previewLocations = ["Patna", "Ranchi", "Gaya", "Delhi"];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
          }
        });
      },
      { threshold: 0 }
    );

    const elements = document.querySelectorAll('.fade-up-element');
    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div>
      <div className="home">
        <div className="background">
          <div className="company-name">
            <h1 className='c-name'>Neha Packers & Movers</h1>
            <p>Your Trusted Partner in Relocation</p>
          </div>
        </div>
        <div className="hero hero-top-right fade-in-load">
          <h1 className="hero-title">Our Top Service Locations</h1>
          <ul className="list-unstyled locations-list">
            {previewLocations.map((city, index) => (
              <li key={index} className="location-item">{city}</li>
            ))}
          </ul>
          <Link to="/service-locations" className="cta animated-btn">
            View All Locations
          </Link>
        </div>
        <div className="hero hero-bottom-left fade-in-load">
          <h1 className="hero-title">Efficient, Safe, and Affordable Relocation Services</h1>
          <Link to="/quote" className="cta animated-btn">Get a Free Quote</Link>
        </div>
      </div>

      <div className="fade-up-element">
        <About />
      </div>

      <div className="fade-up-element">
        <Services />
      </div>

      <div className="fade-up-element">
        <Gallery />
      </div>

      <div className="fade-up-element">
        <Testimonials />
      </div>

      <div className="fade-up-element">
        <ServiceLocations />
      </div>

      <div className="fade-up-element">
        <Contact />
      </div>
    </div>
  );
};
